/*
 * Copyright © 2021 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as React from 'react';
import { withRouter } from "react-router-dom";
import { OrderTracking } from '../models/order-tracking';
import { OrderSubHeader } from '../components/OrderSubHeader';
import { FooterWithLinks } from '../components/FooterWithLinks';
import { FormattedAddress } from '../components/FormattedAddress';
import { StoreService } from '../store.service';
import { ApiService } from '../api.service';
import i18n from '../getText';
import { Preloader } from '../components/Preloader';
import { transformErrorCode } from '../helpers';
import { cloneDeep } from 'lodash';
import { OrderState } from "../types";

interface Params {
  storeService: StoreService,
  history: any
}

class PageState {
  error: boolean = false;
  errorMessage: string = '';
  loaded: boolean = false;
  confirmLoading: boolean = false;
  orderTracking: OrderTracking = null;
  showModal: boolean = false;
  note: string = '';
  message: string = '';
}

class ConfirmOrderPage extends React.Component<Params, PageState> {

  constructor(props) {
    super(props);
    this.state = new PageState();
  }

  componentDidMount() {
    this.props.storeService.load()
      .then(orderTracking => {
        if (orderTracking.state !== OrderState.WAIT_CUSTOMER_LOCATION && !localStorage.getItem('debugMod')) {
          this.props.history.replace({pathname: '/'});
        }
        this.setState({
          orderTracking: cloneDeep(orderTracking),
          note: orderTracking.dropOffAddress.note
        });

      })
      .catch(error => this.setState(error))
      .then(() => this.setState({loaded: true}));

  }

  setNote = (event) => {
    const orderTrackingState = this.state.orderTracking;
    orderTrackingState.dropOffAddress.note = event.target.value;

    this.setState({
      note: event.target.value,
      orderTracking: orderTrackingState
    });
    this.props.storeService.orderTracking.dropOffAddress.note = this.state.note;
  }

  handleContinue = (event) => {
    event.preventDefault();
    this.props.storeService.orderTracking.dropOffAddress.note = this.state.note;

    this.setState({showModal: false});

  }


  handleClickByAddress() {
    this.props.history.replace({pathname: '/select-address'});
  }

  confirm = () => {
    this.setState({
      confirmLoading: true,
      errorMessage: ''
    });

    ApiService.updateDropOffLocation(
      this.props.storeService.trackingNumber,
      this.state.orderTracking.dropOffAddress
    ).then(() => {
      this.props.storeService.loaded = false;
      this.props.history.replace({pathname: '/'});
    }).catch(response => {

      this.setState({
        errorMessage: [
          'Error:',
          response['status'],
          response['statusText']
        ].filter(a => a).join(' ')
      });

      try {
        response.json().then((object) => {

          if (object && object['code']) {
            this.setState({errorMessage: transformErrorCode(object['code'])});
          }
        });
      } catch (e) {
        console.log('ApiService.updateDropOffLocation', e);
      }

    }).then(() => this.setState({confirmLoading: false}))


  };

  render() {

    return (
      <div>


        <article className="site_wrapper">
          <header className="order_header">
            <div className="container">
              <p className="heading ta-c mb-0">
                {i18n.pgettext('ConfirmOrderPage', 'Confirm Your Order')}
              </p>
              {this.state.loaded
              && !this.state.error
              && <OrderSubHeader number={this.state.orderTracking.number} merchant={this.state.orderTracking.merchant}
                                 totalCost={this.state.orderTracking.totalCost}/>}
            </div>
          </header>
          {this.state.loaded && !this.state.error && <main className="content_wrapper flex_content">
            <div className="order_form flex_content-inner">
              <form>

                <div className="order_form-section">
                  <div className="container">

                    <div className="order_group arrow-next" onClick={this.handleClickByAddress}>
                      <div className="order_group-ico">
                        <img src="assets/icDropoffGrey.png"
                             srcSet="assets/icDropoffGrey@2x.png 2x, assets/icDropoffGrey@3x.png 3x"
                             alt="delivery"/>
                      </div>
                      <div className="order_group-details">

                        <p className="order_group-label">
                          {i18n.pgettext('ConfirmOrderPage', 'Delivery location')}
                        </p>
                        <div>
                          <FormattedAddress deliveryAddress={this.state.orderTracking.dropOffAddress}/>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div className="order_form-section">
                  <div className="container">

                    <div className="order_group">
                      <div className="order_group-ico">
                        <img src="assets/icCommentGrey.png"
                             srcSet="assets/icCommentGrey@2x.png 2x, assets/icCommentGrey@3x.png 3x"
                             alt="comment"/>
                      </div>
                      <div className="order_group-details" onClick={() => this.setState({showModal: true})}>
                        <p className="order_group-label">{i18n.pgettext('ConfirmOrderPage', 'Comment')}</p>

                        {this.state.orderTracking.dropOffAddress.note
                          ? <p className="order_group-input">{this.state.orderTracking.dropOffAddress.note}</p>
                          : <p
                            className="order_group-input order_group-input--clickable">{i18n.pgettext('ConfirmOrderPage', 'Add comment')}</p>}

                      </div>
                    </div>

                  </div>
                </div>

                <div className="order_form-section">
                  <div className="container">

                    <button type="button"
                            onClick={this.confirm}
                            disabled={this.state.confirmLoading}
                            className="btn btn-primary btn-block mt-2">
                      {this.state.confirmLoading
                        ? i18n.pgettext('ConfirmOrderPage', 'Confirming ...')
                        : i18n.pgettext('ConfirmOrderPage', 'Confirm')}
                    </button>
                    {this.state.errorMessage && <p className="error_box">{this.state.errorMessage}</p>}


                  </div>
                </div>

              </form>
            </div>
          </main>}

          {this.state.loaded && this.state.error && <main className="content_wrapper">
            <p className="error_box">{this.state.message}</p>
          </main>}

          {!this.state.loaded && <Preloader/>}

          <FooterWithLinks/>
        </article>

        <div className={'modal-layer anim-fade anim-fade--show' + (this.state.showModal ? '' : ' hidden')}>

          <div className="modal-bg" data-modal-close=""/>
          <div className="modal-wrapper">
            <div className="modal-window">
              <div className="modal-content">
                <p className="heading mb-0 ta-c">{i18n.pgettext('SelectAddressPage', 'Additional info')}</p>
                <p className="sub_heading ta-c">{i18n.pgettext('SelectAddressPage', 'Optional')}</p>
                <form>

                  <div className="form_group">
                      <textarea rows={3}
                                value={this.state.note}
                                onChange={this.setNote}
                                className="input"
                                placeholder={i18n.pgettext('SelectAddressPage', 'Comment for Driver')}/>
                  </div>
                  <button
                    onClick={this.handleContinue}
                    className="btn btn-primary btn-block mt-2">
                    {i18n.pgettext('SelectAddressPage', 'Continue')}
                  </button>
                </form>
              </div>
            </div>
          </div>

        </div>

      </div>

    )
  }
}

export default withRouter(ConfirmOrderPage);



// WEBPACK FOOTER //
// ./src/app/pages/ConfirmOrderPage.tsx